import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { AUDIENCES_QUERY, PURCHASED_AUDIENCES_QUERY } from '../queries';

export default function useAudienceNameValidation(value) {
  const { data: dataSavedAudiences } = useQuery(AUDIENCES_QUERY, {
    fetchPolicy: 'cache-and-network',
  });
  const savedAudiences = dataSavedAudiences?.audiences;

  const { data: dataPurchasedAudiences } = useQuery(PURCHASED_AUDIENCES_QUERY, {
    fetchPolicy: 'cache-and-network',
  });
  const purchasedAudiences = dataPurchasedAudiences?.purchasedAudiences;

  const audienceWithNameAlreadyExists = useMemo(() => {
    if (!!savedAudiences?.find(({ name }) => name === value)) {
      return true;
    }
    if (!!purchasedAudiences?.find(({ name }) => name === value)) {
      return true;
    }
    return false;
  }, [purchasedAudiences, savedAudiences, value]);

  const takenNames = useMemo(
    () =>
      savedAudiences
        ?.map(({ name }) => name)
        ?.concat(purchasedAudiences?.map(({ name }) => name)),
    [savedAudiences, purchasedAudiences]
  );

  return { audienceWithNameAlreadyExists, takenNames };
}
